function safeJsonParse(value) {
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export function applyAetherArtifactEvent(acc, event) {
  if (event?.type !== 'artifact' || !event.content) return
  const parsed = safeJsonParse(event.content)
  if (parsed?.kind !== 'project') return
  acc.project = parsed
}
